import { defaultValue } from './util'

export const getDefaultColumnStyleWidth = (
  equalWidthColumns,
  columnWidthMultiplier,
  tableRowAction,
  column,
  isResizable
) => {
  //retaining def column width for larger table for table row action
  if (tableRowAction && column.width && !isResizable) {
    return { width: column.width }
  }

  let defaultColumnStyleWidth = equalWidthColumns
    ? {}
    : {
        ...(columnWidthMultiplier ? { width: `${(columnWidthMultiplier * defaultValue.baseColumnWidth) / 16}rem` } : {})
      }

  return defaultColumnStyleWidth
}

export const getTableCellStyle = (argsData) => {
  const {
    column,
    columns,
    cellProps,
    columnResizing = {},
    columnWidthsObjectState,
    columnWidthsObjectProp,
    equalWidthColumns,
    isResizable,
    tableRowAction
  } = argsData

  let columnWidth = column.width

  let defaultColumnStyleWidth = getDefaultColumnStyleWidth(
    equalWidthColumns,
    column.columnWidthMultiplier,
    tableRowAction,
    column,
    isResizable
  )

  if (!isResizable) {
    //added support for width on column object
    const columnHasWidth = columns.find((singleColumn) => singleColumn.id === column.id && singleColumn.width)
    if (columnHasWidth && typeof columnHasWidth) {
      return { width: columnWidth }
    }
    return defaultColumnStyleWidth
  }

  const columnWidthsArrayProp = Object.keys(columnWidthsObjectProp)
  const columnWidthsArrayState = Object.keys(columnWidthsObjectState)

  if (column.isResizing && columnResizing.isResizingColumn === column.id) {
    return { ...cellProps.style, width: columnResizing.columnWidth }
  }

  if (
    (columnWidthsArrayProp.length > 0 && columnWidthsObjectProp.hasOwnProperty(column.id)) ||
    (columnWidthsArrayState.length > 0 && columnWidthsObjectState.hasOwnProperty(column.id))
  ) {
    return { ...cellProps.style }
  }

  const width = columnWidth || defaultColumnStyleWidth
  return { width }
}

export const getColumnStyle = (argsData) => {
  const {
    column,
    columns,
    cellProps,
    columnWidthsObjectState,
    columnWidthsObjectProp,
    equalWidthColumns,
    isResizable,
    tableRowAction
  } = argsData

  let columnWidth = column.width

  let defaultColumnStyleWidth = getDefaultColumnStyleWidth(
    equalWidthColumns,
    column.columnWidthMultiplier,
    tableRowAction,
    column,
    isResizable
  )

  if (!isResizable) {
    //added support for width on column object
    const columnHasWidth = columns.find((singleColumn) => singleColumn.id === column.id && singleColumn.width)
    if (columnHasWidth && typeof columnHasWidth) {
      return { width: columnWidth }
    }
    return defaultColumnStyleWidth
  }

  const columnWidthsArrayProp = Object.keys(columnWidthsObjectProp)
  const columnWidthsArrayState = Object.keys(columnWidthsObjectState)

  if (
    (columnWidthsArrayProp.length > 0 && columnWidthsObjectProp.hasOwnProperty(column.id)) ||
    (columnWidthsArrayState.length > 0 && columnWidthsObjectState.hasOwnProperty(column.id))
  ) {
    return { ...cellProps.style }
  }

  const width = columnWidth || defaultColumnStyleWidth
  return { width }
}

export const isColumnFreezed = (freezeColumnCount, index) => freezeColumnCount > 0 && index < freezeColumnCount

export const getTableRowClassString = (
  row,
  isRowDisabled,
  rowSelectCheckboxProp,
  viewBy,
  isSingleRowSelected,
  equalWidthColumns,
  rowDisableProp
) => {
  let classname: string = 'Table__body__row '
  if (isRowDisabled) {
    classname = classname + 'Table__body__row--disabled '
  }
  if (equalWidthColumns) {
    classname = classname + 'Table__body__row--equal-width-columns '
  }
  if (row.isSelected) {
    if (rowSelectCheckboxProp && row.original[rowSelectCheckboxProp.key] === rowSelectCheckboxProp.value) {
      if (!(rowDisableProp && row.original[rowDisableProp.key] === rowDisableProp.value)) {
        classname = classname + 'Table__body__row--selected '
      }
    }
    if (!rowSelectCheckboxProp) {
      if (!(rowDisableProp && row.original[rowDisableProp.key] === rowDisableProp.value)) {
        classname = classname + 'Table__body__row--selected '
      }
    }
  }
  if (viewBy === 'Compact') {
    classname = classname + 'Table__body__row--compact '
  }
  if (isSingleRowSelected) {
    classname = classname + 'Table__body__row--selected '
  }
  if (rowDisableProp && row.original[rowDisableProp.key] === rowDisableProp.value) {
    classname = classname + 'Table__body__row--complete-disabled '
  }
  return classname
}
